import React from 'react';

const PageLoading = ({ message, className = '' }) => (
  <div className={`min-h-screen bg-clay-bg flex items-center justify-center ${className}`}>
    <div className="text-center">
      <div className="spinner-fun-lg mx-auto mb-4"></div>
      <p className="text-secondary-text">{message}</p>
    </div>
  </div>
);

export default PageLoading;
